import { render, staticRenderFns } from "./PlpDescription21.vue?vue&type=template&id=e898cb74&scoped=true"
import script from "./PlpDescription21.vue?vue&type=script&lang=js"
export * from "./PlpDescription21.vue?vue&type=script&lang=js"
import style0 from "./PlpDescription21.vue?vue&type=style&index=0&id=e898cb74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e898cb74",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fplp-description-21%2FPlpDescription21.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports